import React from 'react';
import { Link } from 'react-router-dom';
import { Checkbox } from './ui/checkbox';

const PrivacyCheckbox = ({ checked, onCheckedChange, formType = 'generico' }) => {
  const descriptions = {
    iscrizione: 'Acconsento al trattamento dei miei dati personali (nome, cognome, email, telefono, nickname) per la gestione della mia iscrizione al torneo Tecniche Perfette, ai sensi del GDPR (Reg. UE 2016/679).',
    contatto: 'Acconsento al trattamento dei miei dati personali (nome, email, messaggio e allegati) per rispondere alla mia richiesta di contatto, ai sensi del GDPR (Reg. UE 2016/679).',
    profilo: 'Acconsento al trattamento e alla pubblicazione dei miei dati personali (nome, nickname, bio, foto, link social) nella sezione Biografie del sito, ai sensi del GDPR (Reg. UE 2016/679).',
    generico: 'Acconsento al trattamento dei miei dati personali ai sensi del GDPR (Reg. UE 2016/679).'
  };

  return (
    <div className="flex items-start gap-3 p-3 rounded-lg border border-gray-700 bg-gray-900/50">
      <Checkbox
        checked={checked}
        onCheckedChange={onCheckedChange}
        className="mt-0.5 border-gray-500 data-[state=checked]:bg-red-600 data-[state=checked]:border-red-600"
      />
      <label className="text-gray-400 text-xs leading-relaxed cursor-pointer" onClick={() => onCheckedChange(!checked)}>
        {descriptions[formType]}{' '}
        <Link to="/privacy" className="text-red-400 hover:text-red-300 underline" target="_blank">
          Leggi l'informativa completa sulla privacy
        </Link>
        {' '}*
      </label>
    </div>
  );
};

export default PrivacyCheckbox;
